// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import {
  DISMISS_VALIDATION_ERROR,
  SHOW_VALIDATION_ERROR,
} from 'actions/validationError';

export const initialState = {
  field: null,
  errorType: null,
  allowBypassOn: ['address2.missingSecondary'],
};

/* eslint-disable default-case, no-param-reassign */
const validationErrorReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { payload, type } = action;
    switch (type) {
      case SHOW_VALIDATION_ERROR: {
        const { field, errorType } = payload;
        draft.field = field;
        draft.errorType = errorType;
        break;
      }
      case DISMISS_VALIDATION_ERROR: {
        draft.field = null;
        draft.errorType = null;
        break;
      }
    }
  });

export default validationErrorReducer;
